import useTracker from '@/hooks/useTracker';

const EXPAND_ORDER_DETAIL = 'expand_order_detail';

/**
 * @typedef {'Regular'|'Day Trading'|'Margin'|'Hadiah'}  AccountType
 * @typedef {'Limit Order'|'Auto Order'}  OrderType
 * @typedef {'Day'|'Session'}  OrderPeriod
 */

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  /**
   *
   * @param {object}      Params
   * @param {AccountType} Params.accountType
   * @param {OrderType}   Params.orderType
   * @param {OrderPeriod} Params.period
   * @param {number}      Params.price
   * @param {number}      Params.lot
   * @param {number}      Params.total
   * @returns
   */
  const eventExpandOrderDetail = ({ accountType, orderType, period, price, lot, total }) => {
    trackEvent(EXPAND_ORDER_DETAIL, {
      instrument: 'Stock',
      account_type: accountType,
      order_type: orderType,
      period,
      price,
      lot,
      total,
    });
  };

  return {
    eventExpandOrderDetail,
  };
};

export default useEventTracker;
